<div class="">
  <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
  <div class="row mt-2 mb-1" *ngIf="callingLocation!='trendingDashboard'">
    <!--Adding Filter ON for showing user that any Filter is selected or not.-->
    <div class="col-md-3 text-left text-link" [ngClass]="totalFilter > 0 ? 'mt-3' : 'mt-2'">
      <div *ngIf="((resultRegulations.data | async) && ((resultRegulations.data | async).length>0)) && !checkGroupBy()">
        <div>{{endIndex}} out of {{regulations.totalCount}}
          <span *ngIf="selectedItems.length > 0"> ({{selectedItems.length}} selected)</span>
          <span *ngIf="totalFilter > 0"> (Filter ON)</span>
          <!--Adding Filter ON for showing user that any Filter is selected or not.-->
        </div>
      </div>
    </div>
    <div class="col-md-9 mt-2">
      <div class="pull-right">
        <span class="text-blue" (click)="openAappendAssessDialog()" *ngIf="commonService.checkPlanTypeAction('OAA')">
          <lucide-icon name="arrow-right-to-line" size="16" class="text-blue-lucide"></lucide-icon> Append Assess
        </span>
        <span class="text-blue  pl-3" (click)="openAddUpdateDialog()" *ngIf="commonService.checkPlanTypeAction('OAU')">
          <span class="fa fa-plus-square-o"></span> Add Update
        </span>
        <span class="text-blue pl-3" (click)="openEditDialog()" *ngIf="commonService.checkPlanTypeAction('CVEL')">
          <span class="fa fa-pencil-square-o"></span> Edit Library
        </span>
        <span class="text-blue pl-3" (click)="openSharePopup()" *ngIf="commonService.checkPlanTypeAction('OSHL')">
          <span class="fa fa-share-square-o"></span> Share Library
        </span>
        <span class="text-blue pl-3" *ngIf="commonService.checkPlanTypeAction('OSL')"
          (click)="openStaticLibrary()"><span class="fa fa-thumb-tack"></span>
          Static Library</span>
        <span class="text-blue pl-3" *ngIf="commonService.checkPlanTypeAction('ODL')"
          (click)="openDynamicLibrary()"><span class="fa fa-bolt"></span> Dynamic Library</span>
        <span class="text-blue pl-3" (click)="deleteStaticLibraryItem()" *ngIf="regulationLibraryType === 1">
          <span class="fa fa-trash"></span> Delete
        </span>
        <span class="text-blue pl-3" (click)="downloadReport()"
          *ngIf="regulationFilter.FilterType !== 'Future Updates' && commonService.checkPlanTypeAction(erCode)">
          <span class="fa fa-download"></span> Export Report</span>
        <span class="text-blue pl-3" (click)="openPublishReport()" *ngIf="commonService.checkPlanTypeAction('OPR')">
          <span class="fa fa-location-arrow"></span> Publish Report</span>
        <span class="text-blue pl-3 merge_icon" (click)="mergeAssess()"
          *ngIf="regulationFilter.FilterType !== 'Actioned' && commonService.checkPlanTypeAction('OMA')">
          <span [inlineSVG]="'./assets/images/merge.svg'"></span> Merge Assess
        </span>
        <span class="text-blue pl-3" (click)="bulkClose()"
          *ngIf="regulationFilter.FilterType !== 'Actioned' && commonService.checkPlanTypeAction(bcCode)">
          <span class="fa fa-crosshairs"></span> Bulk Close
        </span>
        <!-- <span class="pull-right text-blue pl-3" (click)="bulkAssess()"
            *ngIf="regulationFilter.FilterType === 'Open' && commonService.checkPlanTypeAction('OBAA')">
            <span class="fa fa-code-fork"></span> Bulk Assess</span> -->
        <span class="text-capitalize pl-3" dropdown #dropdownfilters="bs-dropdown" [insideClick]="true"
          [autoClose]="false">

          <span dropdownToggle class="dropdown-toggle custom_badge cursor-pointer text-blue"
            [matBadgeHidden]="totalFilter == 0" matBadge="{{totalFilter}}" (click)="resetFilters($event)">Filters<span
              class="caret" #dropInput></span>
          </span>
          <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu change-viewer-filterDropdown p-3"
            style="width:95%" role="menu" aria-labelledby="button-triggers-manual">
            <div class="dropdown-filter-part">
              <app-regulatory-filters [filterPersistenceKey]="filterPersistenceKey" #regulatoryFiltersComponent
                [userJurisdiction]="userJurisdiction" [ruleTypeName]="" [groupByEnabled]="checkGroupBy()"
                (OnFilter)="OnFilter($event)" (countFiltersItem)="resetFilterItem()" [IsOpenFilter]="IsOpenFilter">
              </app-regulatory-filters>
              <button class="fa fa-times cross-button filter-close-button" (click)="dropInput.click()"></button>
            </div>
          </div>
        </span>

        <span class="pl-3 position-relative" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
          <span dropdownToggle class="cursor-pointer text-blue" (click)="FilterDropdown()">
            <span class="fa fa-cog setting-icon" #dropInputsettings></span>
          </span>
          <div id="dropdown-triggers-manual" *dropdownMenu
            class="dropdown-menu settings-dropdown-menu p-3 dd-height overflow-auto" role="menu"
            aria-labelledby="button-triggers-manual" style="width: 190px">
            <div class="dropdown-filter-part pt-2">
              <div class="item-active" *ngFor="let item of itemActiveModel">
                <input type="checkbox"
                  (change)="showHideColumn(item.itemTitle, item.itemWidth, item.isActive, 'Change')"
                  [(ngModel)]="item.isActive" [attr.checked]="item.isActive ? 'checked' : null" />
                <span class="ml-2">{{ item.itemTitle }}</span>
              </div>
              <button class="fa fa-times cross-button filter-close-button" type="button"
                (click)="dropInputsettings.click()"></button>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <!-- <div class="table-responsive box-shadow"> -->

      <!-- Non Grouped -->
      <div *ngIf="!checkGroupBy()">
        <table class="table table-fixed mb-0">
          <thead style="padding-right: 5px;">
            <tr>
              <th class="pointer col-lg-1 mx-width-8pr text-center" *ngIf="regColumn.id">
                <i class="fa fa-square-o icon-font" (click)="selectAllItem('Checked')"
                  *ngIf="selectedItems.length === 0" aria-hidden="true"></i>
                <i class="fa fa-check-square icon-font" (click)="selectAllItem('UnChecked')"
                  *ngIf="selectedItems.length > 0" aria-hidden="true"></i>
                <span style="margin-left:20px" (click)="sortRegulations('Id')">Id
                  <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Id' && !regulationFilter.IsDesc),
                  'fa-sort-amount-desc': (regulationFilter.SortKey === 'Id' && regulationFilter.IsDesc) }"
                    aria-hidden="true">
                  </i>
                </span>
              </th>
              <th class="pointer col-lg-1 mx-width-8pr" (click)="sortRegulations('Geography')"
                *ngIf="regColumn.geography">
                Geography
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Geography' && !regulationFilter.IsDesc),
                  'fa-sort-amount-desc': (regulationFilter.SortKey === 'Geography' && regulationFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="pointer col-lg-1 mx-width-10pr" (click)="sortRegulations('Country')" *ngIf="regColumn.country">
                Country
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Country' && !regulationFilter.IsDesc),
                  'fa-sort-amount-desc': (regulationFilter.SortKey === 'Country' && regulationFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>

              <th class="pointer col-lg-1 mx-width-8pr" (click)="sortRegulations('Regulator')"
                *ngIf="regColumn.regulator">
                Regulatory
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Regulator' && !regulationFilter.IsDesc),
                  'fa-sort-amount-desc': (regulationFilter.SortKey === 'Regulator' && regulationFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <!-- <th class="pointer col mx-width-6pr text-center px-0" style="width: 55px;"></th> -->
              <th class="pointer col-lg-1 mx-width-9pr" *ngIf="regColumn.publishDate">
                <span (click)="sortRegulations('Date')">
                  Publish Date
                  <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Date' && !regulationFilter.IsDesc),
                  'fa-sort-amount-desc': (regulationFilter.SortKey === 'Date' && regulationFilter.IsDesc) }"
                    aria-hidden="true">
                  </i>
                </span>
                <span dropdown [insideClick]="true" [autoClose]="true"
                  *ngIf="(regulationLibraryId > 0 && regulationLibraryType === 1) || regulationFilter.FilterType === 'Future Updates'">
                  <span class="fa fa-filter p-1 ml-2 border" id="button-basic" dropdownToggle
                    aria-controls="dropdown-basic">
                  </span>
                  <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                    aria-labelledby="button-basic" style="max-height: 150px; overflow-y: auto; max-width: 277px;">
                    <div class="form-group">
                      <app-date-range-picker (DatePickerOutput)="onDatePicker($event)"></app-date-range-picker>
                    </div>
                  </div>
                </span>
              </th>
              <th class="pointer col mx-width-6pr text-center px-0" *ngIf="regColumn.isManual" style="width: 55px;">

              </th>
              <th class="pointer col-lg-2 mx-width-12pr" *ngIf="regColumn.pubType">
                <span (click)="sortRegulations('PubType')">
                  Type
                  <span class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'PubType' && !regulationFilter.IsDesc),
                    'fa-sort-amount-desc': (regulationFilter.SortKey === 'PubType' && regulationFilter.IsDesc) }"
                    aria-hidden="true">
                  </span>
                </span>
              </th>
              <th class="pointer col-lg-1 mx-width-28pr" *ngIf="regColumn.title" (click)="sortRegulations('Title')">
                Title
                <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Title' && !regulationFilter.IsDesc),
                    'fa-sort-amount-desc': (regulationFilter.SortKey === 'Title' && regulationFilter.IsDesc) }"
                  aria-hidden="true">
                </i>
              </th>
              <th class="col-lg-1 text-lg-center mx-width-8pr" scope="col">
                Actions</th>
              <th class="col-lg-1 text-lg-center mx-width-3pr" scope="col"></th>
            </tr>
          </thead>
          <app-progress-bar [isLoading]="isLoadingRegulations"></app-progress-bar>
          <tbody *ngIf="(resultRegulations.data | async) && ((resultRegulations.data | async).length > 0)"
            [style.max-height.px]="myInnerHeight" [ngClass]="isShiftSelect ? 'disable-text-selection' : ''">
            <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="75"
              (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
              *ngIf="(resultRegulations.data | async) && ((resultRegulations.data | async).length > 0)">
              <div *cdkVirtualFor="let item of resultRegulations.data | async; let i = index">
                <tr class="table-tr"
                  [ngClass]="{'table-row' : item.isGreaterThanTodayDate, 'tr-bold' : (item.isRowBold),
                  'selected-row': selectedItemId > 0 && selectedItemId === item.id, 'd-highlight' : checkTransferedItems(item.id)}"
                  (click)="selectedItemId = item.id"
                  (dblclick)="openDetailDialog(item.id, 'All', item.similarityIndex)">
                  <td class="col-lg-1 mx-width-8pr" scope="row" *ngIf="regColumn.id">
                    <span *ngIf="commonService.checkPlanTypeAction('CVEI')">
                      <span class="fa fa-chevron-up arrow-icon" *ngIf="checkCollapsed(item.id)"
                        (click)="showHideData(item.id, 'Hide')"></span>
                      <span class="fa fa-chevron-down arrow-icon" *ngIf="!checkCollapsed(item.id)"
                        (click)="showHideData(item.id, 'Show')"></span>
                    </span>
                    <i class="fa fa-square-o icon-font"
                      (click)="selectItem('Checked', item.id,$event,i,item.impactAssessmentUsers,item.closedRegulationUsers)"
                      *ngIf="!getSelectedItems(item.id)" aria-hidden="true"></i>
                    <i class="fa fa-check-square icon-font"
                      (click)="selectItem('UnChecked', item.id,$event,i,item.impactAssessmentUsers,item.closedRegulationUsers)"
                      *ngIf="getSelectedItems(item.id)" aria-hidden="true"></i>
                    {{item.id}}
                  </td>
                  <td class="col-lg-1 mx-width-8pr tbl-td-scroll" scope="row" *ngIf="regColumn.geography">
                    {{item.geography}}
                  </td>
                  <td class="col-lg-1 mx-width-10pr tbl-td-scroll" scope="row" *ngIf="regColumn.country">
                    {{item.country}}
                  </td>
                  <td class="col-lg-1 mx-width-8pr tbl-td-scroll" scope="row" *ngIf="regColumn.regulator">
                    {{item.regulator}}
                  </td>
                  <!-- <td class="col tbl-td-scroll mx-width-6pr text-center px-0" *ngIf="regColumn.isManual" scope="row"
                    style="width: 55px;">
                    <span [id]="item.id" [pTooltip]="tooltipText" tooltipPosition="bottom"></span>
                    <span (click)="onClick(item.id, item.regulator)">
                      <img src="../../../assets/icons/info-edited.svg" class="my_desc_icon" width="20"
                        alt="description">
                    </span>
                  </td> -->
                  <td class="col-lg-1 mx-width-9pr tbl-td-scroll text-center" scope="row" *ngIf="regColumn.publishDate">
                    {{item.date | date :'d MMM y' }}
                  </td>
                  <td class="col tbl-td-scroll mx-width-6pr text-center px-0" *ngIf="regColumn.isManual" scope="row"
                    style="width: 55px;">
                    <span *ngIf="item.isManual===true">
                      <img _ngcontent-cbv-c209="" src="../../../../assets/images/M_logo.svg" height="25" alt="">
                    </span>
                  </td>
                  <td class="col-lg-2 tbl-td-scroll mx-width-12pr" *ngIf="regColumn.pubType" scope="row"
                    [innerHTML]="item.pubType"></td>

                  <td class="col-lg-1 tbl-td-scroll mx-width-28pr" *ngIf="regColumn.title"
                    title="{{ item.description }}" scope="row">{{item.title}}</td>
                  <td class="col-lg-1 mx-width-8pr">
                    <a (click)="openDetailDialog(item.id, 'All', item.similarityIndex)"
                      *ngIf="commonService.checkPlanTypeAction(vCode)">View
                      | </a>
                    <a href="{{item.hyperlink}}" target="_blank" *ngIf="commonService.checkPlanTypeAction(lCode)"> Link
                      |
                    </a>
                    <!-- <a *ngIf="regulationFilter.FilterType !== 'Actioned' && commonService.checkPlanTypeAction(aCode)"
                      (click)="openPopUp(item.id,item)">Assess | </a> -->
                    <!-- Soustav Start Edit Grey out -->
                    <a *ngIf=" regulationFilter.FilterType !== 'Actioned' && !item.isAssessed  && commonService.checkPlanTypeAction(aCode)"
                      (click)="openPopUp(item.id,item)">Assess | </a>
                    <a *ngIf="regulationFilter.FilterType !== 'Actioned' && regulationFilter.FilterType !== 'Other' && commonService.checkPlanTypeAction(cCode)"
                      (click)="openDialog(item, 'Open')">Close</a>
                    <a *ngIf="(regulationFilter.FilterType === 'Other' || regulationLibraryType > 0) && !item.isClosed && !item.isAssessed && commonService.checkPlanTypeAction(cCode)"
                      (click)="openDialog(item, 'Open')"> Close </a>
                    <a (click)="EditManualUpdate(item.id)" *ngIf="commonService.checkPlanTypeAction(vCode) && item.isManual===true
                        && (!item.closedRegulationUsers || item.closedRegulationUsers.length == 0)
                        && (!item.impactAssessmentUsers || item.impactAssessmentUsers.length == 0)
                        && regulationFilter.FilterType=='Open'"> |
                      Edit </a>
                    <!-- <a (click)="DeleteManualUpdate(item.id)"
                      *ngIf="commonService.checkPlanTypeAction(vCode) && item.isManual===true"> |
                      Delete </a> -->
                    <span
                      *ngIf="(regulationFilter.FilterType === 'Actioned') && (item.closedRegulationUsers.length > 0 || item.impactAssessmentUsers.length > 0) && commonService.checkPlanTypeAction(eCode)">
                      <span
                        *ngIf="checkEditPermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)">
                        <a (click)="openDialog(item, 'Actioned')">Edit</a>
                      </span>
                      <span
                        *ngIf="!checkEditPermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)">
                        <span class="text-muted cursor-default">Edit</span>
                      </span>
                    </span>
                    <span
                      *ngIf="(regulationFilter.FilterType === 'Other') && !checkPermission(item.jurisdiction) && commonService.checkPlanTypeAction(eCode)">
                      <span
                        *ngIf="checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers) && item.isClosed">
                        <a (click)="openDialog(item, 'Actioned')"> Edit</a>
                      </span>
                      <!-- <span
                        *ngIf="!checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers) && !item.isClosed">
                        <span class="text-muted cursor-default">Edit</span>
                      </span> -->
                    </span>
                  </td>
                  <td class="col-lg-1 mx-width-3pr">
                    <span *ngIf="item.closedRegulationUsers && item.closedRegulationUsers.length > 0"
                      [matTooltip]="tooltipValue(item.currentActions)" matTooltipClass="my-tooltip">
                      <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="check-circle"
                        class="svg-inline--fa fa-check-circle fa-w-16 svg-font mb-2" role="img" viewBox="0 0 512 512">
                        <path fill="currentColor"
                          d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z" />
                      </svg>
                    </span>
                    <span *ngIf="item.impactAssessmentUsers && item.impactAssessmentUsers.length > 0"
                      [matTooltip]="tooltipValue(item.currentActions)" matTooltipClass="my-tooltip">
                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tasks"
                        class="svg-inline--fa fa-tasks fa-w-16 svg-font mb-2" role="img" viewBox="0 0 512 512">
                        <path fill="currentColor"
                          d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z" />
                      </svg>
                    </span>
                  </td>
                  <td colspan="12" class="width-100pr border-top-none td-padding" *ngIf="checkCollapsed(item.id)">
                    <div class="row">
                      <div class="col-lg-9">
                        <div class="desc-body">
                          <div class="text-blue pull-right mr-2"
                            (click)="editComment(item.staticLibraryComment, item.id)"
                            *ngIf="regulationFilter.regulationLibraryType == 1">Add Comment</div>
                          <div class="row mb-2" *ngIf="item.staticLibraryComment">
                            <div class="col-lg-2 pl-0">Comments: </div>
                            <ng-container
                              *ngFor="let nlprt of sortArrayByDate(item.staticLibraryComment.split(',')); let i = index">
                              <div class="col-lg-2" *ngIf="i > 0"></div>
                              <div class="col-lg-10 mb-1">
                                <!-- <span (click)="searchRuleTopic(nlprt)">{{nlprt}}</span> -->
                                <!---->
                                <span>{{nlprt}}</span>
                              </div>
                            </ng-container>
                          </div>
                          <span *ngIf="regColumn.orgTopics">
                            <ng-container *ngFor="let clientTopicItemColor of item.clientTopics|jsonStringToArray">
                              <span *ngFor="let clientTopicItemName of sortArray(clientTopicItemColor[1])"
                                class="highlight-text-dinamically rp-highlight item-text"
                                [style.background-color]=" clientTopicItemColor[0]"
                                [style.color]="getContrastYIQ( clientTopicItemColor[0])">
                                <span class="font-weight-normal"
                                  (click)="searchRuleTopic(clientTopicItemName)">{{clientTopicItemName}}</span>
                              </span>
                            </ng-container>
                          </span>
                          <ng-container
                            *ngIf="item.ruleTopic && !item.staticLibraryRuleTopic && regColumn.finregeTopics">
                            <div *ngFor="let rt of sortArray(item.ruleTopic.split(','))"
                              class="highlight-text-blue rp-highlight item-text ruleBorder">
                              <span class="font-weight-normal" (click)="searchRuleTopic(rt)">{{rt}}</span>
                            </div>
                          </ng-container>
                          <ng-container
                            *ngIf="item.nlpRuleTopic && !item.staticLibraryRuleTopic && regColumn.finregeTopics">
                            <div *ngFor="let nlprt of sortArray(item.nlpRuleTopic.split(','))"
                              class="highlight-text-gray rp-highlight item-text ruleBorder">
                              <span class="font-weight-normal" (click)="searchRuleTopic(nlprt)">{{nlprt}}</span>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.staticLibraryRuleTopic && regColumn.finregeTopics">
                            <div *ngFor="let nlprt of sortArray(item.staticLibraryRuleTopic.split(','))"
                              class="highlight-text-gray rp-highlight item-texts">
                              <span class="font-weight-normal" (click)="searchRuleTopic(nlprt)">{{nlprt}}</span>
                            </div>
                          </ng-container>

                          <div class="mt-2" *ngIf="item.similarityIndex">
                            <div>Linked Updates: </div>
                            <div *ngFor="let sindex of getElementsByFilter(item.similarityIndex.split('||'), '')"
                              class="highlight-text-gray rp-highlight item-text ruleBorder">
                              <span class="font-weight-normal"
                                (click)="openDetailDialog(sindex.split('|')[0], 'LinkedUpdates', item.similarityIndex)">{{sindex}}</span>
                            </div>
                            <div *ngIf="item.similarityIndex.split('||').length > 5 && !showMoreLessResult(item.id)"
                              class="highlight-text-gray rp-highlight item-text ruleBorder">
                              <span class="font-weight-normal" (click)="showHideSimilarity(item.id)">Show More </span>
                            </div>
                            <ng-container *ngIf="showMoreLessResult(item.id)">
                              <div *ngFor="let sindex of getElementsByFilter(item.similarityIndex.split('||'), 'All')"
                                class="highlight-text-gray rp-highlight item-text ruleBorder">
                                <span class="font-weight-normal"
                                  (click)="openDetailDialog(sindex.split('|')[0], 'LinkedUpdates', item.similarityIndex)">{{sindex}}</span>
                              </div>
                              <div class="highlight-text-gray rp-highlight item-text ruleBorder">
                                <span class="font-weight-normal" (click)="showHideSimilarity(item.id)">Show Less</span>
                              </div>
                            </ng-container>
                            <div class="highlight-text-gray rp-highlight item-text ruleBorder">
                              <span class="font-weight-normal"
                                (click)="filterSimilarity(item.similarityIndex,item.id)">Show Linked Updates</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-3 side-border" *ngIf="item.currentActions && item.currentActions.length > 0">
                        {{item.currrentActions}}
                        <app-current-action [userId]="user.userId" [itemId]="item.id" [closedType]="" [fromChangeViewer]="true"
                          [currentActions]="item.currentActions" [regulationDetails]="item"
                          (OnFilter)="isCurrentAction($event)" (someEvent)="getRegulation()">
                        </app-current-action>
                      </div>
                    </div>
                  </td>
                </tr>
              </div>
            </cdk-virtual-scroll-viewport>
          </tbody>
          <tbody
            *ngIf="(!(resultRegulations.data | async) || (resultRegulations.data | async).length === 0) && isRegulationFetched">
            <tr>
              <td colspan="9">No data found</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Grouped -->
      <div *ngIf="false">
        <!-- {{ resultRegulations.groupedData | json }}test -->
        <app-progress-bar [isLoading]="isLoadingRegulations"></app-progress-bar>
        <mat-accordion>
          <mat-expansion-panel *ngFor="let item of regulations.groupedData"
            (opened)="item.panelOpenState = true; getPannelData(item.groupByColumnData)"
            (closed)="item.panelOpenState = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ item.groupByColumnData }}
              </mat-panel-title>
              <mat-panel-description>
                {{ item.totalCount }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div *ngIf="item.panelOpenState">
              <table class="table table-fixed mb-0">
                <thead style="padding-right: 5px;">
                  <tr>
                    <th class="pointer col-lg-1 mx-width-8pr text-center" *ngIf="regColumn.id">
                      <i class="fa fa-square-o icon-font" (click)="selectAllItem('Checked')"
                        *ngIf="selectedItems.length === 0" aria-hidden="true"></i>
                      <i class="fa fa-check-square icon-font" (click)="selectAllItem('UnChecked')"
                        *ngIf="selectedItems.length > 0" aria-hidden="true"></i>
                      <span style="margin-left:20px" (click)="sortRegulations('Id')">Id
                        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Id' && !regulationFilter.IsDesc),
                      'fa-sort-amount-desc': (regulationFilter.SortKey === 'Id' && regulationFilter.IsDesc) }"
                          aria-hidden="true">
                        </i>
                      </span>
                    </th>
                    <th class="pointer col-lg-1 mx-width-8pr" (click)="sortRegulations('Geography')"
                      *ngIf="regColumn.geography">
                      Geography
                      <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Geography' && !regulationFilter.IsDesc),
                      'fa-sort-amount-desc': (regulationFilter.SortKey === 'Geography' && regulationFilter.IsDesc) }"
                        aria-hidden="true">
                      </i>
                    </th>
                    <th class="pointer col-lg-1 mx-width-10pr" (click)="sortRegulations('Country')"
                      *ngIf="regColumn.country">
                      Country
                      <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Country' && !regulationFilter.IsDesc),
                      'fa-sort-amount-desc': (regulationFilter.SortKey === 'Country' && regulationFilter.IsDesc) }"
                        aria-hidden="true">
                      </i>
                    </th>
                    <th class="pointer col-lg-1 mx-width-8pr" (click)="sortRegulations('Regulator')"
                      *ngIf="regColumn.regulator">
                      Regulator
                      <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Regulator' && !regulationFilter.IsDesc),
                      'fa-sort-amount-desc': (regulationFilter.SortKey === 'Regulator' && regulationFilter.IsDesc) }"
                        aria-hidden="true">
                      </i>
                    </th>
                    <!-- <th class="pointer col mx-width-6pr text-center px-0" style="width: 55px;"></th> -->
                    <th class="pointer col-lg-1 mx-width-9pr" *ngIf="regColumn.publishDate">
                      <span (click)="sortRegulations('Date')">
                        Publish Date
                        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Date' && !regulationFilter.IsDesc),
                      'fa-sort-amount-desc': (regulationFilter.SortKey === 'Date' && regulationFilter.IsDesc) }"
                          aria-hidden="true">
                        </i>
                      </span>
                      <span dropdown [insideClick]="true" [autoClose]="true"
                        *ngIf="(regulationLibraryId > 0 && regulationLibraryType === 1) || regulationFilter.FilterType === 'Future Updates'">
                        <span class="fa fa-filter p-1 ml-2 border" id="button-basic" dropdownToggle
                          aria-controls="dropdown-basic">
                        </span>
                        <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                          aria-labelledby="button-basic" style="max-height: 150px; overflow-y: auto; max-width: 277px;">
                          <div class="form-group">
                            <app-date-range-picker (DatePickerOutput)="onDatePicker($event)"></app-date-range-picker>
                          </div>
                        </div>
                      </span>
                    </th>
                    <th class="pointer col mx-width-6pr text-center px-0" *ngIf="regColumn.isManual"
                      style="width: 55px;">

                    </th>
                    <th class="pointer col-lg-2 mx-width-12pr" *ngIf="regColumn.pubType">
                      <span (click)="sortRegulations('PubType')">
                        Type
                        <span class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'PubType' && !regulationFilter.IsDesc),
                        'fa-sort-amount-desc': (regulationFilter.SortKey === 'PubType' && regulationFilter.IsDesc) }"
                          aria-hidden="true">
                        </span>
                      </span>
                    </th>
                    <th class="pointer col-lg-1 mx-width-28pr" *ngIf="regColumn.title"
                      (click)="sortRegulations('Title')">
                      Title
                      <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Title' && !regulationFilter.IsDesc),
                        'fa-sort-amount-desc': (regulationFilter.SortKey === 'Title' && regulationFilter.IsDesc) }"
                        aria-hidden="true">
                      </i>
                    </th>
                    <th class="col-lg-1 text-lg-center mx-width-8pr" scope="col">
                      Actions</th>
                    <th class="col-lg-1 text-lg-center mx-width-3pr" scope="col"></th>
                  </tr>
                </thead>
                <app-progress-bar [isLoading]="isLoadingRegulations"></app-progress-bar>
                <tbody *ngIf="(resultRegulations.data | async) && ((resultRegulations.data | async).length > 0)"
                  [style.max-height.px]="myInnerHeight" [ngClass]="isShiftSelect ? 'disable-text-selection' : ''">
                  <cdk-virtual-scroll-viewport class="list-container list-group" itemSize="50"
                    (scrolledIndexChange)="handler($event)" [style.height.px]="myInnerHeight"
                    *ngIf="(resultRegulations.data | async) && ((resultRegulations.data | async).length > 0)">
                    <div *cdkVirtualFor="let item of resultRegulations.data | async; let i = index">
                      <tr class="table-tr"
                        [ngClass]="{'table-row' : item.isGreaterThanTodayDate, 'tr-bold' : (item.isRowBold),
                      'selected-row': selectedItemId > 0 && selectedItemId === item.id, 'd-highlight' : checkTransferedItems(item.id)}"
                        (click)="selectedItemId = item.id"
                        (dblclick)="openDetailDialog(item.id, 'All', item.similarityIndex)">
                        <td class="col-lg-1 mx-width-8pr" scope="row" *ngIf="regColumn.id">
                          <span *ngIf="commonService.checkPlanTypeAction('CVEI')">
                            <span class="fa fa-chevron-up arrow-icon" *ngIf="checkCollapsed(item.id)"
                              (click)="showHideData(item.id, 'Hide')"></span>
                            <span class="fa fa-chevron-down arrow-icon" *ngIf="!checkCollapsed(item.id)"
                              (click)="showHideData(item.id, 'Show')"></span>
                          </span>
                          <i class="fa fa-square-o icon-font"
                            (click)="selectItem('Checked', item.id,$event,i,item.impactAssessmentUsers,item.closedRegulationUsers)"
                            *ngIf="!getSelectedItems(item.id)" aria-hidden="true"></i>
                          <i class="fa fa-check-square icon-font"
                            (click)="selectItem('UnChecked', item.id,$event,i,item.impactAssessmentUsers,item.closedRegulationUsers)"
                            *ngIf="getSelectedItems(item.id)" aria-hidden="true"></i>
                          {{item.id}}
                        </td>
                        <td class="col-lg-1 mx-width-8pr tbl-td-scroll" scope="row" *ngIf="regColumn.geography">
                          {{item.geography}}
                        </td>
                        <td class="col-lg-1 mx-width-10pr tbl-td-scroll" scope="row" *ngIf="regColumn.country">
                          {{item.country}}
                        </td>
                        <td class="col-lg-1 mx-width-8pr tbl-td-scroll" scope="row" *ngIf="regColumn.regulator">
                          {{item.regulator}}
                        </td>
                        <!-- <td class="col tbl-td-scroll mx-width-6pr text-center px-0" *ngIf="regColumn.isManual"
                          scope="row" style="width: 55px;">
                          <span [id]="item.regulator" [pTooltip]="tooltipText" tooltipPosition="bottom"></span>
                          <span (click)="onClick(item.id, item.regulator)">
                            <img src="../../../assets/icons/info-edited.svg" class="my_desc_icon" width="28"
                              alt="description">
                          </span>
                        </td> -->
                        <td class="col-lg-1 mx-width-9pr tbl-td-scroll text-center" scope="row"
                          *ngIf="regColumn.publishDate">
                          {{item.date | date :'d MMM y' }}
                        </td>
                        <td class="col tbl-td-scroll mx-width-6pr text-center px-0" *ngIf="regColumn.isManual"
                          scope="row" style="width: 55px;">
                          <span *ngIf="item.isManual===true">
                            <img _ngcontent-cbv-c209="" src="../../../../assets/images/M_logo.svg" height="25" alt="">
                          </span>
                        </td>
                        <td class="col-lg-2 tbl-td-scroll mx-width-12pr" *ngIf="regColumn.pubType" scope="row"
                          [innerHTML]="item.pubType"></td>

                        <td class="col-lg-1 tbl-td-scroll mx-width-28pr" *ngIf="regColumn.title"
                          title="{{ item.description }}" scope="row">{{item.title}}</td>
                        <td class="col-lg-1 mx-width-8pr">
                          <a (click)="openDetailDialog(item.id, 'All', item.similarityIndex)"
                            *ngIf="commonService.checkPlanTypeAction(vCode)">View
                            | </a>
                          <a href="{{item.hyperlink}}" target="_blank" *ngIf="commonService.checkPlanTypeAction(lCode)">
                            Link
                            |
                          </a>
                          <a *ngIf="regulationFilter.FilterType !== 'Actioned' && commonService.checkPlanTypeAction(aCode)"
                            (click)="openPopUp(item.id,item,item.groupByColumnData,i)">Assess | </a>
                          <a *ngIf="regulationFilter.FilterType !== 'Actioned' && regulationFilter.FilterType !== 'Other' && commonService.checkPlanTypeAction(cCode)"
                            (click)="openDialog(item, 'Open',item.groupByColumnData,pannel.groupByColumnData, pannel.clickFilter, pannelIndex)">Close</a>
                          <a *ngIf="(regulationFilter.FilterType !== 'Actioned' && regulationFilter.FilterType === 'Other' || regulationLibraryType > 0) && (checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)) && commonService.checkPlanTypeAction(cCode)"
                            (click)="openDialog(item, 'Open',item.groupByColumnData, pannel.clickFilter, pannelIndex)">Close</a>
                          <a (click)="EditManualUpdate(item.id)" *ngIf="commonService.checkPlanTypeAction(vCode) && item.isManual===true
                            && (!item.closedRegulationUsers || item.closedRegulationUsers.length == 0)
                            && (!item.impactAssessmentUsers || item.impactAssessmentUsers.length == 0)
                            && regulationFilter.FilterType=='Open'"> |
                            Edit </a>
                          <!-- <a (click)="DeleteManualUpdate(item.id)"
                          *ngIf="commonService.checkPlanTypeAction(vCode) && item.isManual===true"> |
                          Delete </a> -->
                          <span
                            *ngIf="(regulationFilter.FilterType === 'Actioned') && (item.closedRegulationUsers.length > 0 || item.impactAssessmentUsers.length > 0) && commonService.checkPlanTypeAction(eCode)">
                            <span
                              *ngIf="checkEditPermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)">
                              <a (click)="openDialog(item, 'Actioned',item.groupByColumnData)">Edit</a>
                            </span>
                            <span
                              *ngIf="!checkEditPermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)">
                              <span class="text-muted cursor-default">Edit</span>
                            </span>
                          </span>
                          <span
                            *ngIf="(regulationFilter.FilterType === 'Other') && !checkPermission(item.jurisdiction) && commonService.checkPlanTypeAction(eCode)">
                            <span
                              *ngIf="checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)">
                              <a (click)="openDialog(item, 'Actioned',item.groupByColumnData)">Edit</a>
                            </span>
                            <span
                              *ngIf="!checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)">
                              <span class="text-muted cursor-default">Edit</span>
                            </span>
                          </span>
                        </td>
                        <td class="col-lg-1 mx-width-3pr">
                          <span *ngIf="item.closedRegulationUsers && item.closedRegulationUsers.length > 0"
                            [matTooltip]="tooltipValue(item.currentActions)" matTooltipClass="my-tooltip">
                            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="check-circle"
                              class="svg-inline--fa fa-check-circle fa-w-16 svg-font mb-2" role="img"
                              viewBox="0 0 512 512">
                              <path fill="currentColor"
                                d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z" />
                            </svg>
                          </span>
                          <span *ngIf="item.impactAssessmentUsers && item.impactAssessmentUsers.length > 0"
                            [matTooltip]="tooltipValue(item.currentActions)" matTooltipClass="my-tooltip">
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tasks"
                              class="svg-inline--fa fa-tasks fa-w-16 svg-font mb-2" role="img" viewBox="0 0 512 512">
                              <path fill="currentColor"
                                d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z" />
                            </svg>
                          </span>
                        </td>
                        <td colspan="12" class="width-100pr border-top-none td-padding" *ngIf="checkCollapsed(item.id)">
                          <div class="row">
                            <div class="col-lg-9">
                              <div class="desc-body">
                                <div class="text-blue pull-right mr-2"
                                  (click)="editComment(item.staticLibraryComment, item.id)"
                                  *ngIf="regulationFilter.regulationLibraryType == 1">Add Comment</div>
                                <div class="row mb-2" *ngIf="item.staticLibraryComment">
                                  <div class="col-lg-2 pl-0">Comments: </div>
                                  <ng-container
                                    *ngFor="let nlprt of sortArrayByDate(item.staticLibraryComment.split(',')); let i = index">
                                    <div class="col-lg-2" *ngIf="i > 0"></div>
                                    <div class="col-lg-10 mb-1">
                                      <!-- <span (click)="searchRuleTopic(nlprt)">{{nlprt}}</span> -->
                                      <!---->
                                      <span>{{nlprt}}</span>
                                    </div>
                                  </ng-container>
                                </div>
                                <span *ngIf="regColumn.orgTopics">
                                  <ng-container
                                    *ngFor="let clientTopicItemColor of item.clientTopics|jsonStringToArray">
                                    <span *ngFor="let clientTopicItemName of sortArray(clientTopicItemColor[1])"
                                      class="highlight-text-dinamically rp-highlight item-text"
                                      [style.background-color]=" clientTopicItemColor[0]"
                                      [style.color]="getContrastYIQ( clientTopicItemColor[0])">
                                      <span class="font-weight-normal"
                                        (click)="searchRuleTopic(clientTopicItemName)">{{clientTopicItemName}}</span>
                                    </span>
                                  </ng-container>
                                </span>
                                <ng-container
                                  *ngIf="item.ruleTopic && !item.staticLibraryRuleTopic && regColumn.finregeTopics">
                                  <div *ngFor="let rt of sortArray(item.ruleTopic.split(','))"
                                    class="highlight-text-blue rp-highlight item-text ruleBorder">
                                    <span class="font-weight-normal" (click)="searchRuleTopic(rt)">{{rt}}</span>
                                  </div>
                                </ng-container>
                                <ng-container
                                  *ngIf="item.nlpRuleTopic && !item.staticLibraryRuleTopic && regColumn.finregeTopics">
                                  <div *ngFor="let nlprt of sortArray(item.nlpRuleTopic.split(','))"
                                    class="highlight-text-gray rp-highlight item-text ruleBorder">
                                    <span class="font-weight-normal" (click)="searchRuleTopic(nlprt)">{{nlprt}}</span>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="item.staticLibraryRuleTopic && regColumn.finregeTopics">
                                  <div *ngFor="let nlprt of sortArray(item.staticLibraryRuleTopic.split(','))"
                                    class="highlight-text-gray rp-highlight item-texts">
                                    <span class="font-weight-normal" (click)="searchRuleTopic(nlprt)">{{nlprt}}</span>
                                  </div>
                                </ng-container>

                                <div class="mt-2" *ngIf="item.similarityIndex">
                                  <div>Linked Updates: </div>
                                  <div *ngFor="let sindex of getElementsByFilter(item.similarityIndex.split('||'), '')"
                                    class="highlight-text-gray rp-highlight item-text ruleBorder">
                                    <span class="font-weight-normal"
                                      (click)="openDetailDialog(sindex.split('|')[0], 'LinkedUpdates', item.similarityIndex)">{{sindex}}</span>
                                  </div>
                                  <div
                                    *ngIf="item.similarityIndex.split('||').length > 5 && !showMoreLessResult(item.id)"
                                    class="highlight-text-gray rp-highlight item-text ruleBorder">
                                    <span class="font-weight-normal" (click)="showHideSimilarity(item.id)">Show
                                      More</span>
                                  </div>
                                  <ng-container *ngIf="showMoreLessResult(item.id)">
                                    <div
                                      *ngFor="let sindex of getElementsByFilter(item.similarityIndex.split('||'), 'All')"
                                      class="highlight-text-gray rp-highlight item-text ruleBorder">
                                      <span class="font-weight-normal"
                                        (click)="openDetailDialog(sindex.split('|')[0], 'LinkedUpdates', item.similarityIndex)">{{sindex}}</span>
                                    </div>
                                    <div class="highlight-text-gray rp-highlight item-text ruleBorder">
                                      <span class="font-weight-normal" (click)="showHideSimilarity(item.id)">Show
                                        Less</span>
                                    </div>
                                  </ng-container>
                                  <div class="highlight-text-gray rp-highlight item-text ruleBorder">
                                    <span class="font-weight-normal"
                                      (click)="filterSimilarityByGrouped(item.similarityIndex,item.id)">Show Linked
                                      Updates</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 side-border"
                              *ngIf="item.currentActions && item.currentActions.length > 0">
                              <app-current-action [userId]="user.userId" [itemId]="item.id" [closedType]="" [fromChangeViewer]="true"
                                [currentActions]="item.currentActions" [regulationDetails]="item"
                                (OnFilter)="isCurrentAction($event)" (someEvent)="getRegulation()">
                              </app-current-action>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </div>
                  </cdk-virtual-scroll-viewport>
                </tbody>
                <tbody
                  *ngIf="(!(resultRegulations.data | async) || (resultRegulations.data | async).length === 0) && isRegulationFetched">
                  <tr>
                    <td colspan="9">No data found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>


      <!-- Grouping NGRX -->
      <div *ngIf="checkGroupBy()">
        <!-- {{ resultRegulations.groupedData | json }}test -->
        <div class="row change_viewer_row">
          <div class="col-12">
            <!-- <mat-form-field>
              <mat-label>Filter</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>
            </mat-form-field> -->

            <div class="form-group mb-0">
              <!-- <div class="left inline control-label mb-1">Group Filter</div> -->
              <mat-chip-grid #searchList>
                <ng-container *ngFor="let item of groupFilter">
                  <mat-chip-row [selectable]="true" [removable]="true" (removed)="removeFromFilter(item)">
                    {{item}}
                    <mat-icon matChipRemove class="clear-icons">clear</mat-icon>
                  </mat-chip-row>
                </ng-container>
                <input class="panel_group_filterInput form-control form-control-sm mat-autodd-input border-bottom "
                  placeholder="Group Filter" #ruleTopicInput [formControl]="searchFilterFormControl"
                  [matAutocomplete]="searchFilter" [matChipInputFor]="searchList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="applyFilter($event)">
              </mat-chip-grid>

              <mat-autocomplete #searchFilter="matAutocomplete" (optionSelected)="selectApplyFilter($event)"
                class="panel_group_autocomplete">
                <mat-option *ngFor="let item of searchFilterFormList" [title]="item" [value]="item">
                  {{item}}
                </mat-option>
              </mat-autocomplete>

            </div>
          </div>
          <!-- <div class="col-4">

            <mat-paginator *ngIf="filteredGroupData.length>0" [length]="filteredGroupData.length" [pageSize]="20"
              [pageIndex]="groupPageIndex" [showFirstLastButtons]="true"
              (page)="pannelPaginaation($event)"></mat-paginator>
          </div> -->
        </div>
        <app-progress-bar [isLoading]="isLoadingRegulations"></app-progress-bar>
        <div class="change_viewer_mainPanel">
          <mat-accordion multi>
            <ng-container *ngFor="let pannel of filteredGroupData; let pannelIndex=index">
              <mat-expansion-panel *ngIf="pannelIndex<(15*(groupPageIndex+1))&& pannelIndex>=(15*groupPageIndex)"
                [expanded]="pannel.panelOpenState" hideToggle
                (opened)="pannel.panelOpenState?'':updatePannelOpenState(pannel.groupByColumnData,true,pannel.pannelData.length)"
                (closed)="updatePannelOpenState(pannel.groupByColumnData,false)">
                <mat-expansion-panel-header class="changeV_panelHeader">
                  <mat-panel-title class="changeV_matTitle d-flex justify-content-between align-items-center">
                    <div class="d-flex">
                      <span class="fa fa-chevron-up arrow-icon" *ngIf="pannel.panelOpenState"></span>
                      <span class="fa fa-chevron-down arrow-icon" *ngIf="!pannel.panelOpenState"></span>
                      <span class="pannel_title">{{
                        pannel.groupByColumnData }}</span>
                    </div>
                    <div class="mat-numbers"
                      (click)="$event.stopPropagation(); pannel.pageIndex=0;pannel.clickFilter=null; getPannelData(pannel.groupByColumnData); pannel.panelOpenState=true">
                      <span [ngClass]="pannel.isActionDone  ? 'round_box_changeVclose' : 'round_box_changeV'">
                        {{ pannel.totalCount }}
                      </span>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description class="changeV_description">
                    <div class="data_panel">
                      <div *ngFor="let otherData of pannel.otherDataSummary"
                        (click)="$event.stopPropagation(); pannel.pageIndex=0;pannel.clickFilter=otherData.mappingIdOrPubType; getPannelData(pannel.groupByColumnData,otherData.mappingIdOrPubType); pannel.panelOpenState=true"
                        class="data_panel_inner">
                        <span [ngClass]="otherData.isActioned  ? 'round_box_changeVcloseSmall' : 'round_box_changeV'">
                          <!-- <span class="round_box_changeV"> -->
                          {{ otherData.totalCount }}
                        </span>
                        <span>
                          {{ otherData.mappingIdOrPubType }}
                        </span>
                      </div>
                    </div>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <!-- <div *ngIf="pannel.panelOpenState"> -->
                <div class="ml-3">
                  <div class="row mb-1">
                    <div class="col-6 d-flex my-auto pl-5">
                      <span *ngIf="getSelectedPannelItems(pannel.pannelData)>0" class="text-blue">
                        {{ getSelectedPannelItems(pannel.pannelData) }} selected
                      </span>
                      <span
                        *ngIf="getSelectedPannelItems(pannel.pannelData) == 0 || getSelectedPannelItems(pannel.pannelData) < 0"
                        class="text-white">
                        0 selected
                      </span>
                    </div>
                  </div>
                  <table class="table table-fixed mb-0">
                    <thead class="table_header_group">
                      <tr>
                        <th class="pointer col-lg-1 mx-width-8pr text-center" *ngIf="regColumn.id">
                          <i class="fa fa-square-o icon-font"
                            (click)="selectAllPannelItem('Checked', pannel,pannelIndex)"
                            *ngIf="!pannel.isPanelIdSelected" aria-hidden="true"></i>
                          <i class="fa fa-check-square icon-font"
                            (click)="selectAllPannelItem('UnChecked', pannel,pannelIndex)"
                            *ngIf="pannel.isPanelIdSelected" aria-hidden="true"></i>
                          <span style="margin-left:20px"
                            (click)="sortGroupRegulations(pannel.groupByColumnData,'Id')">Id
                            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Id' && !regulationFilter.IsDesc),
                            'fa-sort-amount-desc': (regulationFilter.SortKey === 'Id' && regulationFilter.IsDesc) }"
                              aria-hidden="true">
                            </i>
                          </span>
                        </th>
                        <th class="pointer col-lg-1 mx-width-8pr"
                          (click)="sortGroupRegulations(pannel.groupByColumnData,'Geography')"
                          *ngIf="regColumn.geography">
                          Geography
                          <i class="fa"
                            [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Geography' && !regulationFilter.IsDesc),
                            'fa-sort-amount-desc': (regulationFilter.SortKey === 'Geography' && regulationFilter.IsDesc) }"
                            aria-hidden="true">
                          </i>
                        </th>
                        <th class="pointer col-lg-1 mx-width-10pr"
                          (click)="sortGroupRegulations(pannel.groupByColumnData,'Country')" *ngIf="regColumn.country">
                          Country
                          <i class="fa"
                            [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Country' && !regulationFilter.IsDesc),
                            'fa-sort-amount-desc': (regulationFilter.SortKey === 'Country' && regulationFilter.IsDesc) }"
                            aria-hidden="true">
                          </i>
                        </th>
                        <th class="pointer col-lg-1 mx-width-8pr"
                          (click)="sortGroupRegulations(pannel.groupByColumnData,'Regulator')"
                          *ngIf="regColumn.regulator">
                          Regulator
                          <i class="fa"
                            [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Regulator' && !regulationFilter.IsDesc),
                            'fa-sort-amount-desc': (regulationFilter.SortKey === 'Regulator' && regulationFilter.IsDesc) }"
                            aria-hidden="true">
                          </i>
                        </th>
                        <th class="pointer col-lg-1 mx-width-9pr" *ngIf="regColumn.publishDate">
                          <span (click)="sortGroupRegulations(pannel.groupByColumnData,'Date')">
                            Publish Date
                            <i class="fa" [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Date' && !regulationFilter.IsDesc),
                            'fa-sort-amount-desc': (regulationFilter.SortKey === 'Date' && regulationFilter.IsDesc) }"
                              aria-hidden="true">
                            </i>
                          </span>
                          <span dropdown [insideClick]="true" [autoClose]="true"
                            *ngIf="(regulationLibraryId > 0 && regulationLibraryType === 1) || regulationFilter.FilterType === 'Future Updates'">
                            <span class="fa fa-filter p-1 ml-2 border" id="button-basic" dropdownToggle
                              aria-controls="dropdown-basic">
                            </span>
                            <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                              aria-labelledby="button-basic"
                              style="max-height: 150px; overflow-y: auto; max-width: 277px;">
                              <div class="form-group">
                                <app-date-range-picker (DatePickerOutput)="onDatePicker($event)">
                                </app-date-range-picker>
                              </div>
                            </div>
                          </span>
                        </th>
                        <th class="pointer col mx-width-6pr text-center px-0" *ngIf="regColumn.isManual"
                          style="width: 55px;">

                        </th>
                        <th class="pointer col-lg-2 mx-width-12pr" *ngIf="regColumn.pubType">
                          <span (click)="sortGroupRegulations(pannel.groupByColumnData,'PubType')">
                            Type
                            <span class="fa"
                              [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'PubType' && !regulationFilter.IsDesc),
                              'fa-sort-amount-desc': (regulationFilter.SortKey === 'PubType' && regulationFilter.IsDesc) }"
                              aria-hidden="true">
                            </span>
                          </span>
                        </th>
                        <th class="pointer col-lg-1 mx-width-28pr" *ngIf="regColumn.title"
                          (click)="sortGroupRegulations(pannel.groupByColumnData,'Title')">
                          Title
                          <i class="fa"
                            [ngClass]="{'fa-sort-amount-asc': (regulationFilter.SortKey === 'Title' && !regulationFilter.IsDesc),
                              'fa-sort-amount-desc': (regulationFilter.SortKey === 'Title' && regulationFilter.IsDesc) }"
                            aria-hidden="true">
                          </i>
                        </th>
                        <th class="col-lg-1 text-lg-center mx-width-8pr" scope="col">
                          Actions</th>
                        <th class="col-lg-1 text-lg-center mx-width-3pr" scope="col"></th>
                      </tr>
                    </thead>
                    <app-progress-bar [isLoading]="pannel.isLoading"></app-progress-bar>
                    <tbody *ngIf="(pannel.pannelData) && ((pannel.pannelData).length > 0)"
                      [ngClass]="isShiftSelect ? 'disable-text-selection' : ''" class="no-scroll">
                      <div *ngFor="let item of pannel.pannelData; let i = index">
                        <div *ngIf="i>=(pannel.pageIndex*pannel.pageSize) && i<((pannel.pageIndex+1)*pannel.pageSize)">
                          <tr class="table-tr"
                            [ngClass]="{'table-row' : item.isGreaterThanTodayDate, 'tr-bold' : (item.isRowBold),
                            'selected-row': selectedItemId > 0 && selectedItemId === item.id, 'd-highlight' : checkTransferedItems(item.id)}"
                            (click)="selectedItemId = item.id"
                            (dblclick)="openDetailDialog(item.id, 'All', item.similarityIndex, pannel.pannelData)">
                            <td class="col-lg-1 mx-width-8pr" scope="row" *ngIf="regColumn.id">
                              <span *ngIf="commonService.checkPlanTypeAction('CVEI')">
                                <span class="fa fa-chevron-up arrow-icon" *ngIf="checkCollapsed(item.id)"
                                  (click)="showHideData(item.id, 'Hide')"></span>
                                <span class="fa fa-chevron-down arrow-icon" *ngIf="!checkCollapsed(item.id)"
                                  (click)="showHideData(item.id, 'Show')"></span>
                              </span>
                              <i class="fa fa-square-o icon-font"
                                (click)="selectPanelItem('Checked', item.id,$event,i,pannelIndex, item.country, item.regulator, item.pubType, item.closedRegulationUsers, item.impactAssessmentUsers)"
                                *ngIf="!getSelectedItems(item.id)" aria-hidden="true"></i>
                              <i class="fa fa-check-square icon-font"
                                (click)="selectPanelItem('UnChecked', item.id,$event,i,pannelIndex)"
                                *ngIf="getSelectedItems(item.id)" aria-hidden="true"></i>
                              {{item.id}}
                            </td>
                            <td class="col-lg-1 mx-width-8pr tbl-td-scroll" scope="row" *ngIf="regColumn.geography">
                              {{item.geography}}
                            </td>
                            <td class="col-lg-1 mx-width-10pr tbl-td-scroll" scope="row" *ngIf="regColumn.country">
                              {{item.country}}
                            </td>
                            <td class="col-lg-1 mx-width-8pr tbl-td-scroll" scope="row" *ngIf="regColumn.regulator">
                              {{item.regulator}}
                            </td>
                            <td class="col-lg-1 mx-width-9pr tbl-td-scroll text-center" scope="row"
                              *ngIf="regColumn.publishDate">
                              {{item.date | date :'d MMM y' }}
                            </td>
                            <td class="col tbl-td-scroll mx-width-6pr text-center px-0" *ngIf="regColumn.isManual"
                              scope="row" style="width: 55px;">
                              <span *ngIf="item.isManual===true">
                                <img _ngcontent-cbv-c209="" src="../../../../assets/images/M_logo.svg" height="25"
                                  alt="">
                              </span>
                            </td>
                            <td class="col-lg-2 tbl-td-scroll mx-width-12pr" *ngIf="regColumn.pubType" scope="row"
                              [innerHTML]="item.pubType"></td>

                            <td class="col-lg-1 tbl-td-scroll mx-width-28pr" *ngIf="regColumn.title"
                              title="{{ item.description }}" scope="row">{{item.title}}</td>
                            <td class="col-lg-1 mx-width-8pr">
                              <a (click)="openDetailDialog(item.id, 'All', item.similarityIndex, pannel.pannelData)"
                                *ngIf="commonService.checkPlanTypeAction(vCode)">View
                                | </a>
                              <a href="{{item.hyperlink}}" target="_blank"
                                *ngIf="commonService.checkPlanTypeAction(lCode)">
                                Link
                                |
                              </a>
                              <a *ngIf="(!item.impactAssessmentUsers || item.impactAssessmentUsers == '') && regulationFilter.FilterType !== 'Actioned' && commonService.checkPlanTypeAction(aCode)"
                                (click)="openPopUp(item.id,item,pannel.groupByColumnData, pannel.clickFilter, pannelIndex)">Assess
                                | </a>
                              <a *ngIf="(!item.closedRegulationUsers || item.closedRegulationUsers == '') && regulationFilter.FilterType !== 'Actioned' && regulationFilter.FilterType !== 'Other' && commonService.checkPlanTypeAction(cCode)"
                                (click)="openDialog(item, 'Open',pannel.groupByColumnData, pannel.clickFilter, pannelIndex)">Close</a>
                              <a *ngIf="(!item.closedRegulationUsers || item.closedRegulationUsers == '') && (regulationFilter.FilterType === 'Other') && (checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)) && commonService.checkPlanTypeAction(cCode)"
                                (click)="openDialog(item, 'Open',pannel.groupByColumnData, pannel.clickFilter, pannelIndex)">Close</a>
                              <a (click)="EditManualUpdate(item.id)" *ngIf="commonService.checkPlanTypeAction(vCode) && item.isManual===true
                                  && (item.closedRegulationUsers.length > 0)
                                  && regulationFilter.FilterType=='Open'"> |
                                Edit</a>
                              <!-- <a (click)="DeleteManualUpdate(item.id)"
                                *ngIf="commonService.checkPlanTypeAction(vCode) && item.isManual===true"> |
                                Delete </a> -->
                              <span
                                *ngIf="(regulationFilter.FilterType === 'Actioned') && (item.closedRegulationUsers.length > 0 || item.impactAssessmentUsers.length > 0) && commonService.checkPlanTypeAction(eCode)">
                                <span
                                  *ngIf="checkEditPermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)">
                                  <a (click)="openDialog(item, 'Actioned',pannel.groupByColumnData)">Edit</a>
                                </span>
                                <span
                                  *ngIf="!checkEditPermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)">
                                  <span class="text-muted cursor-default">Edit</span>
                                </span>
                              </span>
                              <span
                                *ngIf="(regulationFilter.FilterType === 'Other') && !checkPermission(item.jurisdiction) && commonService.checkPlanTypeAction(eCode) && (item.closedRegulationUsers.length > 0)">
                                <span
                                  *ngIf="checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)">
                                  <a (click)="openDialog(item, 'Actioned',pannel.groupByColumnData)">Edit</a>
                                </span>
                                <span
                                  *ngIf="!checkClosePermission(item.closedRegulationUsers, item.jurisdiction, item.impactAssessmentUsers)">
                                  <span class="text-muted cursor-default">Edit</span>
                                </span>
                              </span>
                            </td>
                            <td class="col-lg-1 mx-width-3pr">
                              <span *ngIf="item.closedRegulationUsers && item.closedRegulationUsers.length > 0"
                                [matTooltip]="tooltipValue(item.currentActions)" matTooltipClass="my-tooltip">
                                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="check-circle"
                                  class="svg-inline--fa fa-check-circle fa-w-16 svg-font mb-2" role="img"
                                  viewBox="0 0 512 512">
                                  <path fill="currentColor"
                                    d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z" />
                                </svg>
                              </span>
                              <span *ngIf="item.impactAssessmentUsers && item.impactAssessmentUsers.length > 0"
                                [matTooltip]="tooltipValue(item.currentActions)" matTooltipClass="my-tooltip">
                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tasks"
                                  class="svg-inline--fa fa-tasks fa-w-16 svg-font mb-2" role="img"
                                  viewBox="0 0 512 512">
                                  <path fill="currentColor"
                                    d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z" />
                                </svg>
                              </span>
                            </td>
                            <td colspan="12" class="width-100pr border-top-none td-padding"
                              *ngIf="checkCollapsed(item.id)">
                              <div class="row">
                                <div class="col-lg-9">
                                  <div class="desc-body">
                                    <div class="text-blue pull-right mr-2"
                                      (click)="editComment(item.staticLibraryComment, item.id)"
                                      *ngIf="regulationFilter.regulationLibraryType == 1">Add Comment</div>
                                    <div class="row mb-2" *ngIf="item.staticLibraryComment">
                                      <div class="col-lg-2 pl-0">Comments: </div>
                                      <ng-container
                                        *ngFor="let nlprt of sortArrayByDate(item.staticLibraryComment.split(',')); let i = index">
                                        <div class="col-lg-2" *ngIf="i > 0"></div>
                                        <div class="col-lg-10 mb-1">
                                          <!-- <span (click)="searchRuleTopic(nlprt)">{{nlprt}}</span> -->
                                          <!---->
                                          <span>{{nlprt}}</span>
                                        </div>
                                      </ng-container>
                                    </div>
                                    <span *ngIf="regColumn.orgTopics">
                                      <ng-container
                                        *ngFor="let clientTopicItemColor of item.clientTopics|jsonStringToArray">
                                        <span *ngFor="let clientTopicItemName of sortArray(clientTopicItemColor[1])"
                                          class="highlight-text-dinamically rp-highlight item-text"
                                          [style.background-color]=" clientTopicItemColor[0]"
                                          [style.color]="getContrastYIQ( clientTopicItemColor[0])">
                                          <span class="font-weight-normal"
                                            (click)="searchRuleTopic(clientTopicItemName)">{{clientTopicItemName}}</span>
                                        </span>
                                      </ng-container>
                                    </span>
                                    <ng-container
                                      *ngIf="item.ruleTopic && !item.staticLibraryRuleTopic && regColumn.finregeTopics">
                                      <div *ngFor="let rt of sortArray(item.ruleTopic.split(','))"
                                        class="highlight-text-blue rp-highlight item-text ruleBorder">
                                        <span class="font-weight-normal" (click)="searchRuleTopic(rt)">{{rt}}</span>
                                      </div>
                                    </ng-container>
                                    <ng-container
                                      *ngIf="item.nlpRuleTopic && !item.staticLibraryRuleTopic && regColumn.finregeTopics">
                                      <div *ngFor="let nlprt of sortArray(item.nlpRuleTopic.split(','))"
                                        class="highlight-text-gray rp-highlight item-text ruleBorder">
                                        <span class="font-weight-normal"
                                          (click)="searchRuleTopic(nlprt)">{{nlprt}}</span>
                                      </div>
                                    </ng-container>
                                    <ng-container *ngIf="item.staticLibraryRuleTopic && regColumn.finregeTopics">
                                      <div *ngFor="let nlprt of sortArray(item.staticLibraryRuleTopic.split(','))"
                                        class="highlight-text-gray rp-highlight item-texts">
                                        <span class="font-weight-normal"
                                          (click)="searchRuleTopic(nlprt)">{{nlprt}}</span>
                                      </div>
                                    </ng-container>

                                    <div class="mt-2" *ngIf="item.similarityIndex">
                                      <div>Linked Updates: </div>
                                      <div
                                        *ngFor="let sindex of getElementsByFilter(item.similarityIndex.split('||'), '')"
                                        class="highlight-text-gray rp-highlight item-text ruleBorder">
                                        <span class="font-weight-normal"
                                          (click)="openDetailDialog(sindex.split('|')[0], 'LinkedUpdates', item.similarityIndex)">{{sindex}}</span>
                                      </div>
                                      <div
                                        *ngIf="item.similarityIndex.split('||').length > 5 && !showMoreLessResult(item.id)"
                                        class="highlight-text-gray rp-highlight item-text ruleBorder">
                                        <span class="font-weight-normal" (click)="showHideSimilarity(item.id)">Show
                                          More </span>
                                      </div>
                                      <ng-container *ngIf="showMoreLessResult(item.id)">
                                        <div
                                          *ngFor="let sindex of getElementsByFilter(item.similarityIndex.split('||'), 'All')"
                                          class="highlight-text-gray rp-highlight item-text ruleBorder">
                                          <span class="font-weight-normal"
                                            (click)="openDetailDialog(sindex.split('|')[0], 'LinkedUpdates', item.similarityIndex)">{{sindex}}</span>
                                        </div>
                                        <div class="highlight-text-gray rp-highlight item-text ruleBorder">
                                          <span class="font-weight-normal" (click)="showHideSimilarity(item.id)">Show
                                            Less</span>
                                        </div>
                                      </ng-container>
                                      <div class="highlight-text-gray rp-highlight item-text ruleBorder">
                                        <span class="font-weight-normal"
                                          (click)="filterSimilarityByGrouped(item.similarityIndex,item.id)">Show Linked
                                          Updates</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-3 side-border"
                                  *ngIf="item.currentActions && item.currentActions.length > 0">
                                  <app-current-action [userId]="user.userId" [itemId]="item.id" [closedType]="" [fromChangeViewer]="true"
                                    [currentActions]="item.currentActions" [regulationDetails]="item"
                                    (OnFilter)="isCurrentAction($event)" (someEvent)="getRegulation()">
                                  </app-current-action>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </div>
                      </div>

                    </tbody>
                    <tbody *ngIf="(!(pannel.pannelData) || (pannel.pannelData).length === 0) && isRegulationFetched">
                      <tr>
                        <td colspan="9">No data found</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row">
                  <div class="col-6 d-flex my-auto pl-5 text-blue">
                    <span *ngIf="getSelectedPannelItems(pannel.pannelData)>0">
                      {{ getSelectedPannelItems(pannel.pannelData) }} selected
                    </span>
                  </div>
                  <div class="col-6">
                    <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" [length]="pannel.activeItemCount"
                      [pageIndex]="pannel.pageIndex" [pageSize]="pannel.pageSize"
                      (page)="groupingPagination(pannel.groupByColumnData,$event,pannelIndex, pannel.clickFilter)"
                      class="pannel_container_paginator"></mat-paginator>
                  </div>
                </div>
                <span>
                </span>
                <!-- </div> -->
              </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
        </div>

        <mat-paginator *ngIf="filteredGroupData.length>0" [hidePageSize]="true" class="pannel_container_paginatorFixed"
          [length]="filteredGroupData.length" [pageSize]="15" [pageIndex]="groupPageIndex" [showFirstLastButtons]="true"
          (page)="pannelPaginaation($event)"></mat-paginator>
      </div>


      <!-- </div> -->
    </div>
    <div class="col-md-12 col-lg-12" *ngIf="isLoadingPagination">
      <div class="col-md-12 col-lg-3 p-0 mt-2 pull-right">
        <app-progress-bar [isLoading]="true"></app-progress-bar>
      </div>
    </div>
  </div>
</div>
<!-- <div class="backdrop-filter" *ngIf="isBackdropVisible" (click)="BackDropVisible()"></div> -->